import { makeStyles } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { primary, secondary, text } = theme.palette;

  return {
    formContainer: {
      display: "flex",
      flexDirection: "column",
      gap: 4,
      padding: "0 0 30px",
      marginTop: 20,
      [theme.breakpoints.down(Breakpoints.MD_960)]: {
        padding: 0
      }
    },
    entryHeader: {
      color: primary.dark,
      fontSize: 14,
      marginTop: 15,
      marginBottom: 10
    },
    field: {
      flexGrow: 1,
      minWidth: "calc(50% - 10px)",
      maxWidth: "calc(50% - 10px)",
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        minWidth: "100%",
        maxWidth: "100%",
        width: "100%"
      },
      "& .MuiFormLabel-root": {
        color: text.secondary
      }
    },
    searchField: {
      position: "relative",
      minWidth: "100%",
      maxWidth: "100%",
      "& .MuiInputBase-input": {
        height: 35
      },
      [theme.breakpoints.down(Breakpoints.MD_960)]: {
        minWidth: "calc(50% - 10px)",
        maxWidth: "calc(50% - 10px)"
      },
      [theme.breakpoints.down(Breakpoints.SX_720)]: {
        minWidth: "100%",
        maxWidth: "100%"
      }
    },
    searchIcon: {
      top: 11
    },
    clearIcon: {
      top: 8
    },
    input: {
      fontSize: 12,
      "&::placeholder": {
        fontSize: 12
      }
    },
    itemsList: {
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        position: "absolute",
        top: 34,
        border: `1px solid ${primary.main}`,
        height: 284,
        overflowY: "auto",
        "& .MuiListItem-root": {
          height: 47
        },
        "& .MuiListItem-root[class*='noSearchResultButton']": {
          height: "25vh"
        }
      }
    },
    buttonGroup: {
      flexGrow: 1,
      minWidth: "100%",
      maxWidth: "100%"
    },
    header: {
      fontSize: 14
    },
    commentTextarea: {
      marginBottom: 20,
      "& .MuiInputBase-root": {
        fontSize: 12,
        padding: 12
      },
      "& .MuiInputBase-input": {
        minHeight: 107,
        maxHeight: 107,
        lineHeight: "normal"
      },
      "& .MuiOutlinedInput-root fieldset": {
        borderColor: primary.light
      },
      "& .MuiOutlinedInput-root:hover fieldset": {
        borderColor: primary.main
      },
      "& .MuiOutlinedInput-root:hover.Mui-focused fieldset": {
        borderColor: secondary.dark
      }
    },
    submitButton: {
      width: 176,
      height: 45,
      marginTop: 20,
      color: "#fff",
      border: "none",
      borderRadius: 2,
      alignSelf: "end",
      backgroundColor: secondary.dark,
      "&:hover": {
        backgroundColor: secondary.dark
      },
      "&.Mui-disabled": {
        backgroundColor: "#eee",
        color: primary.light,
        border: "none"
      }
    },
    loader: {
      alignItems: "start",
      marginTop: 80
    }
  };
});
